var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"comp-wrap"},[_c('Search')],1),_c('div',{staticClass:"comp-wrap"},[_c('Featured')],1),_c('div',{staticClass:"comp-wrap"},[_c('FiveDayWeather')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }